import workspaceQuery from '../../../graphql/queries/product/StockAdjustmentLabelWorkspaceQuery.graphql';
import fragment from '../../../graphql/fragments/product/StockAdjustmentLabelFragment.graphql';
import instanceQuery from '../../../graphql/queries/product/StockAdjustmentLabelQuery.graphql';

import generateMutation from '../../../graphql/mutations/product/StockAdjustmentLabelGenerateMutation.graphql';
import generateRangeMutation from '../../../graphql/mutations/product/StockAdjustmentLabelGenerateRangeMutation.graphql';
import reprintMutation from '../../../graphql/mutations/product/StockAdjustmentLabelReprintMutation.graphql';

import * as printFunctions from '../../../actions/product/StockAdjustmentLabelPrintActions';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const StockAdjustmentLabel: EntityType = {
  type: 'StockAdjustmentLabel',
  title: 'Receipt Label (Stock Adjustment)',
  formTitle: 'Print Receipt Labels (Stock Adjustments)',
  workspaceUrl: '/Product/StockAdjustmentLabel/Workspace/',
  workspace: workspaceQuery,
  generate: generateMutation,
  instance: instanceQuery,
  generateRange: generateRangeMutation,
  reprint: reprintMutation,
  fragment,
  printFunctions: printFunctions,
  actions: [],
  configuration: {
    title: 'Receipt Label (Stock Adjustment)',
    reportType: ReportType.StockAdjustmentLabel,
    field: 'stockAdjustmentLabelDocumentDefault',
  },
  screenReference: 'STOCK_ADJUSTMENT_LABEL',
};

export default StockAdjustmentLabel;
